module.exports = __webpack_public_path__ + "static/media/pin.86e20f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pin.png
// module id = 17
// module chunks = 0